import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { compose, setDisplayName } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { FormContainer } from 'containers/common/formContainer/FormContainer'
import { Text } from 'components/text/Text'

import styles from './SubmittedPage.module.scss'

const mapStateToProps = (state, props) => {
  const parsedSearch = qs.parse(props.history.location.search) || {}
  const redirectType = parsedSearch.type

  return {
    redirectType,
  }
}

const SubmittedPageCmp = ({ redirectType }) => {
  let message = <Text size={16}>You have already answered the questionnaire. Thank you for your time!</Text>

  if (redirectType === 'FROM_FEEDBACK') {
    message = (
      <Text size={16}>
        Thank you for submitting the questionnaire! <br /> ESS HR will review your answers and contact you if additional
        information is required.
      </Text>
    )
  }

  if (redirectType === 'NO_FORM') {
    message = <Text size={16}>You don{"'"}t have any questionnaires to submit.</Text>
  }

  return (
    <FormContainer>
      <div className={styles.content}>{message}</div>
    </FormContainer>
  )
}

SubmittedPageCmp.propTypes = {
  redirectType: PropTypes.string,
}

export const SubmittedPage = compose(
  setDisplayName('SubmittedPage'),
  withRouter,
  connect(mapStateToProps, null),
)(SubmittedPageCmp)
